import { flattenLeaves, UnifiedLayerConfig } from '../../utils/index';
import { mockLayers } from '../../global/constants/layers';

export interface Layer {
  title: string;
  key?: string;
  children?: Layer[];
}

const allEpeNames: string[] = flattenLeaves(mockLayers).map(
  (cfg: UnifiedLayerConfig) => cfg.name
);

export const geoLayers: Layer[] = [
  {
    title: 'Infraestrutura e Mobilidade',
    children: [
      { title: 'Gasodutos de distribuição' },
      { title: 'Gasodutos de transporte' },
    ],
  },
  {
    title: 'Pernambuco e suas águas - Infraestrutura Hídrica',
    children: [
      { title: 'Bases de estações fluviométricas' },
      { title: 'Bases de estações pluviométricas' },
    ],
  },
  {
    title: 'Informações Socioambientais',
    children: [
      {
        title: 'Unidades de Conservação Ambiental',
        key: 'Unidades de Conservação Ambiental',
      },
      { title: 'Territórios quilombolas', key: 'Territórios quilombolas' },
      {
        title: 'Terras indígenas (Homologadas)',
        key: 'Terras indígenas (Homologadas)',
      },
      { title: 'Sítios Arqueológicos', key: 'Sítios Arqueológicos' },
      {
        title: 'Aves Migratórias (Áreas de Concentração)',
        key: 'Aves Migratórias (Áreas de Concentração)',
      },
      { title: 'Cavernas', key: 'Cavernas' },
    ],
  },
  {
    title: 'Bases de Combustíveis - Cenários',
    children: [
      { title: 'Petróleo e Derivados', key: 'Petróleo e Derivados' },
      {
        title: 'Regasificação Gás Natural Liquefeito (GNL)',
        key: 'Regasificação Gás Natural Liquefeito (GNL)',
      },
      {
        title: 'Gás Liquefeito de Petróleo (GLP)',
        key: 'Gás Liquefeito de Petróleo (GLP)',
      },
      { title: 'Bases de Combustíveis', key: 'Bases de Combustíveis' },
      {
        title: 'Exploração e Produção de Hidrocarbonetos',
        key: 'Exploração e Produção de Hidrocarbonetos',
      },
    ],
  },
  // {
  //   title: 'Camadas EPE',
  //   children: allEpeNames.map((name) => ({ title: name, key: name })),
  // },
  {
    title: 'Unidades Administrativas',
    children: [
      { title: 'Limite BRA', key: 'Limite BRA' },
      { title: 'Estados BRA', key: 'Estados BRA' },
      { title: 'Estado PE', key: 'Estado PE' },
      { title: 'Municípios PE', key: 'Municípios PE' },
    ],
  },
  {
    title: 'Sistema Elétrico e Potencial Eólico',
    children: [
      {
        title: 'Parques Eólicos',
      },
      {
        title: 'Usinas Fotovotaicas',
      },
      {
        title: 'Usinas Hidrelétricas',
      },
      {
        title: 'Centrais Geradoras Hidrelétricas',
      },
      {
        title: 'Usinas de combustível fóssil (Termelétricas)',
      },
      {
        title: 'Linhas de Transmissão',
      },
      // {
      //   title: 'Subestações',
      // },
    ],
  },
  {
    title: 'Sistema Elétrico e Potencial Solar',
    children: [
      {
        title: 'Irradiação Global Horizontal Anual (Wh/m².dia)',
      },
      {
        title: 'Irradiação Direta Normal Anual (Wh/m².dia)',
      },
      {
        title: 'Irradiação no Plano Inclinado Anual (Wh/m².dia)',
      },
      {
        title: 'Parques Eólicos',
      },
      // {
      //   title: 'Usinas Fotovotaicas',
      // },
      {
        title: 'Usinas Hidrelétricas',
      },
      {
        title: 'Centrais Geradoras Hidrelétricas',
      },
      {
        title: 'Usinas de combustível fóssil (Termelétricas)',
      },
      {
        title: 'Linhas de Transmissão',
      },
      {
        title: 'Subestações',
      },
    ],
  },
];
